import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		padding: 40px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 16px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 20px;
			padding: 40px 12px;
		}
	`,
}
export default Style
